import './VenueShortlist.css';
import React, { useEffect, useRef, useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, getDictionaryItem, canUseDOM, getGlobalDictionaryTerm, getPageThemeColors, getColorByTheme } from '../../utils';
import IconStar from '../../resources/icons/star.svg';
import ShortlistBtn from '../atoms/ShortlistBtn/ShortlistBtn';
import DateRange from '../Listing/DateRange';
import FileUpload from './FileUpload';
import getListing from '../../utils/getListing';
import { getVenuesApi } from '../../utils/venues';
import { useLocation } from 'react-router-dom';
import { IconToggleArrowDown } from '../atoms/Icons';
import { tealiumClickFunc } from '../../utils/tealium';
import Recaptcha from '../Login/components/Recaptcha';
const VenueShortlist = _ref => {
  let {
    fields,
    isOpen,
    setOpen,
    analytics,
    formIdModifier
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const currentLang = get(sitecoreContext, 'language');
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const indexVenues = get(sitecoreContext, 'configuration.indexValues.venues') || 'qa_venues_en';
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const venueThankYouPage = get(sitecoreContext, 'configuration.venueThankYouPage') || '/';
  const closeVenuesLabel = getGlobalDictionaryTerm(sitecoreContext, 'closeVenuesLabel') || 'Close venues';
  const contentBody = useRef();
  const {
    removeVenueFromShortlistAnalytics,
    shareYourShortlistAnalytics,
    requestProposalAnalytics,
    yourShortlistedBottomAnalytics,
    yourShortlistedTopAnalytics,
    interactionWithVenueRPFormAnalytics
  } = analytics;
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [isInteractionAvaialble, setIsInteractionAvaialble] = useState(true);
  const [cards, setCards] = useState([]);
  const [loadNo, setLoadNo] = useState(0);
  const [openBar, setOpenBar] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const appLocation = useLocation();
  const [appLocationPath, setAppLocationPath] = React.useState('');
  const [formShare, setFormShare] = useState('');
  const [formShareError, setFormShareError] = useState('');
  const [formShareSent, setFormShareSent] = useState(false);
  const [submittedCheck, setSubmittedCheck] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [formFullName, setFormFullName] = useState('');
  const [formEmail, setFormEmail] = useState('');
  const [formPhone, setFormPhone] = useState('');
  const [formStartDate, setFormStartDate] = useState('');
  const [formEndDate, setFormEndDate] = useState('');
  const [formNumberOfDelegates, setFormNumberOfDelegates] = useState();
  const [formEventName, setFormEventName] = useState('');
  const [formCompanyName, setFormCompanyName] = useState('');
  const [formComments, setFormComments] = useState('');
  const [formFiles, setFormFiles] = useState([]);
  const [formFullNameError, setFormFullNameError] = useState('');
  const [formEmailError, setFormEmailError] = useState('');
  const [formPhoneError, setFormPhoneError] = useState('');
  const [formNumberOfDelegatesError, setFormNumberOfDelegatesError] = useState('');
  const [formStartDateError, setFormStartDateError] = useState('');
  const [formFilesError, setFormFilesError] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState('');
  const [recaptchaShareEmailError, setRecaptchaShareEmailError] = useState('');
  const recaptchaRef = useRef(null);
  const recaptchaShareEmailRef = useRef(null);
  const [venueIds, setVenueIds] = useState([]);
  const [removedVenue, setRemovedVenue] = useState(false);
  const dictionaryValues = get(fields, 'dictionary.dictionary', {
    dictionaryValues: []
  });
  const venuesDictionaryValues = get(fields, 'dictionary.dictionaryVenues', {
    dictionaryValues: []
  });
  const requiredError = getDictionaryItem(venuesDictionaryValues, 'required') || '%required%';
  const invalidFormatError = getDictionaryItem(venuesDictionaryValues, 'invalidFormat') || '%invalidFormat%';
  const allowedEmailsAre10Error = getDictionaryItem(venuesDictionaryValues, 'allowedEmailsAre10') || '%allowedEmailsAre10%';
  const validateRecaptchaError = getDictionaryItem(venuesDictionaryValues, 'validateRecaptcha') || '%validateRecaptcha%';
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const shortlistVenues = hits => {
    setCards(hits.map((hit, index) => {
      if (!!hit) {
        let category = hit.category;
        if (hit.category && hit.category.join) {
          category = hit.category.join(',');
        }
        return {
          category: category,
          title: hit.title,
          phone: hit.phone,
          email: hit.email,
          englishTitle: hit.englishTitle,
          url: hit.url,
          hotelStarRating: parseInt(hit.hotelStarRating),
          objectID: hit.objectID
        };
      } else {
        return {
          category: '',
          title: '',
          phone: '',
          email: '',
          englishTitle: '',
          url: '',
          hotelStarRating: 0,
          objectID: String(index)
        };
      }
    }));
  };
  const onSubmit = async () => {
    let isValid = !formFilesError;
    let recaptchaToken;
    if (recaptchaShareEmailRef.current) {
      recaptchaToken = await recaptchaShareEmailRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      isValid = false;
      setRecaptchaShareEmailError(validateRecaptchaError);
    } else {
      setRecaptchaError('');
    }
    const validations = [[formEmail, v => v.indexOf('@') > -1, setFormEmailError], [formFullName, v => /^[A-Za-z\u0621-\u064A ]+$/.test(v), setFormFullNameError], [formStartDate, () => true, setFormStartDateError], [formNumberOfDelegates, () => true, setFormNumberOfDelegatesError], [formFiles, v => !!v.length, setFormFilesError]];
    validations.forEach(_ref2 => {
      let [value, validator, setError] = _ref2;
      if (!value) {
        setError(requiredError);
        isValid = false;
      } else if (!validator(value)) {
        setError(invalidFormatError);
        isValid = false;
      }
    });
    const fileUploadData = new FormData();
    fileUploadData.set('language', currentLang);
    fileUploadData.set('g-recaptcha-response', recaptchaToken);
    if (formFullName) {
      fileUploadData.set('fullName', formFullName);
    }
    if (formEmail) {
      fileUploadData.set('email', formEmail);
    }
    if (formPhone) {
      fileUploadData.set('phone', formPhone);
    }
    if (formStartDate) {
      fileUploadData.set('startDate', formStartDate);
    }
    if (formEndDate) {
      fileUploadData.set('endDate', formEndDate);
    }
    if (formNumberOfDelegates) {
      fileUploadData.set('numberOfDelegates', String(formNumberOfDelegates));
    }
    if (formEventName) {
      fileUploadData.set('eventName', formEventName);
    }
    if (formCompanyName) {
      fileUploadData.set('companyName', formCompanyName);
    }
    if (formComments) {
      fileUploadData.set('comments', formComments);
    }
    formFiles.forEach(file => {
      fileUploadData.append('file', file);
    });
    if (cards.length) {
      fileUploadData.set('venues', JSON.stringify(cards.map(card => ({
        title: Array.isArray(card.title) ? card.title[0] : card.title,
        phone: card.phone,
        email: card.email,
        url: card.url
      }))));
    }
    setSubmitted(true);
    setLoading(true);
    if (cards.length) {
      cards.forEach(card => {
        tealiumClickFunc(requestProposalAnalytics, Array.isArray(card.title) ? card.title[0] : card.title);
      });
    }
    await fetch(`${apiGlobal}/api/form/RequestProposal`, {
      method: 'post',
      body: fileUploadData
    }).then(res => {
      res.json().then(json => {
        if (res.status === 400) {
          if (json.Email) {
            setFormEmailError(requiredError);
          }
          if (json.FullName) {
            setFormFullNameError(requiredError);
          }
          if (json.StartDate) {
            setFormStartDateError(requiredError);
          }
          if (json.NumberOfDelegates) {
            setFormNumberOfDelegatesError(requiredError);
          }
        } else {
          setFormEmailError('');
          setFormFullNameError('');
          setFormStartDateError('');
          setFormNumberOfDelegatesError('');
          setSubmitted(false);
          if (canUseDOM) {
            window.location.href = venueThankYouPage;
          }
        }
        setLoading(false);
      });
    }).finally(() => setLoading(false));
  };
  const handleFormFiles = function (e, currentFieldModel, fieldValue, fieldKey, defaultEvent, confirmValue) {
    let analytics = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
    triggerInteraction();
    setFormFiles(fieldValue);
  };
  const shareEmails = async e => {
    if (!cards.length) {
      return;
    }
    if (!formShare) {
      setFormShareError(requiredError);
      return;
    }
    if (formShare.split(',').filter(v => v.indexOf('@') > -1).length > 10) {
      setFormShareError(allowedEmailsAre10Error);
      return;
    }
    if (formShare.indexOf('@') === -1) {
      setFormShareError(invalidFormatError);
      return;
    }
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(validateRecaptchaError);
    } else {
      setRecaptchaError('');
    }
    const fileUploadData = new FormData();
    fileUploadData.set('language', currentLang);
    fileUploadData.set('g-recaptcha-response', recaptchaToken);
    fileUploadData.set('emails', formShare);
    fileUploadData.set('venues', JSON.stringify(cards.map(card => ({
      title: Array.isArray(card.title) ? card.title[0] : card.title,
      phone: card.phone,
      email: card.email,
      url: card.url
    }))));
    tealiumClickFunc(shareYourShortlistAnalytics);
    await fetch(`${apiGlobal}/api/form/shareShortlist`, {
      method: 'post',
      body: fileUploadData
    }).then(res => {
      res.json().then(json => {
        if (res.status === 400) {
          // setFormShareError(requiredError);
        } else {
          setFormShareSent(true);
          setFormShareError('');
          setFormShare('');
        }
      });
    });
  };
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  useEffect(() => {
    if (submittedCheck) {
      if (contentBody && contentBody.current) {
        const c = contentBody.current;
        if (formFullNameError || formEmailError || formNumberOfDelegatesError || formStartDateError) {
          c.scrollTop = c.querySelectorAll('.form-error')[0].previousSibling.previousSibling.offsetTop - c.previousSibling.offsetHeight - 15;
        } else if (c.querySelectorAll('.form-field__error').length) {
          c.scrollTop = c.querySelectorAll('.venue-shortlist__docs')[0].offsetTop - c.previousSibling.offsetHeight - 15;
        } else if (c.querySelectorAll('.lr__error').length) {
          c.scrollTop = c.querySelectorAll('.venue-shortlist__footer')[0].offsetTop - c.previousSibling.offsetHeight - 15;
        }
      }
    }
  }, [submittedCheck]);
  useEffect(() => {
    if (canUseDOM) {
      setVenueIds(JSON.parse(localStorage.getItem('shortlistVenues') || '[]'));
      if (document.body) {
        const primaryColor = selectedPrimaryColor;
        const color = getColorByTheme(selectedPrimaryColor);
        const activeColor = selectedPrimaryActiveColor;
        document.body.style.setProperty('--venue-table-background-color', primaryColor);
        document.body.style.setProperty('--venue-table-background-active-color', activeColor);
        document.body.style.setProperty('--venue-table-color', color);
      }
    }
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setFormShareError('');
      setRecaptchaError('');
      setFormEmailError('');
      setFormPhoneError('');
      setFormFullNameError('');
      setFormStartDateError('');
      setFormNumberOfDelegatesError('');
    }, 300);
    if (canUseDOM) {
      const toggleFn = event => {
        ['.venue-shortlist__close', '.venue-shortlist__back', '.venue-header__bar-btn'].forEach(className => {
          if (event.target.closest(className)) {
            event.preventDefault();
            setIsInteractionAvaialble(!isOpen);
            setOpen(!isOpen);
            if (className === '.main-navigation__shortlist') {
              tealiumClickFunc(yourShortlistedTopAnalytics);
            }
            if (className === '.venue-header__bar-btn') {
              tealiumClickFunc(yourShortlistedBottomAnalytics);
            }
          }
        });
      };
      window.addEventListener('click', toggleFn);
      return () => {
        window.removeEventListener('click', toggleFn);
      };
    }
  }, [isOpen]);
  useEffect(() => {
    if (canUseDOM) {
      const triggerUpdate = () => {
        setLoadNo(loadNo + 1);
        if (canUseDOM) {
          const ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
          if (venueIds.some(id => ids.indexOf(id) === -1)) {
            setRemovedVenue(true);
          } else {
            setRemovedVenue(false);
          }
          setVenueIds(ids);
        }
      };
      document.body.addEventListener('shortlistVenues', triggerUpdate);
      return () => {
        document.body.removeEventListener('shortlistVenues', triggerUpdate);
      };
    }
  }, [isOpen, loadNo, venueIds]);
  useEffect(() => {
    if (canUseDOM) {
      let ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
      if (ids.length) {
        var itemFilters = {
          filters: ids.map(id => `(objectID:${id})`).join(' OR '),
          facetFilters: [['type:Venue']],
          hitsPerPage: 100,
          page: 0
        };
        shortlistVenues(cards.filter(card => ids.indexOf(card.objectID) > -1));
        getListing(indexVenues, itemFilters, algoliaSettings).then(response => {
          shortlistVenues(response.hits);
        });
      } else {
        shortlistVenues([]);
      }
    }
  }, [loadNo]);
  useEffect(() => {
    if (canUseDOM) {
      const closeSidebar = event => {
        const notCaptchaBox = get(event.target, 'parentElement.parentElement') !== document.body;
        if (!event.target.closest('.venue-shortlist__container') && notCaptchaBox) {
          setIsInteractionAvaialble(false);
          setOpen(false);
        }
      };
      document.body.addEventListener('click', closeSidebar);
      return () => {
        document.body.removeEventListener('click', closeSidebar);
      };
    }
  }, []);
  useEffect(() => {
    if (canUseDOM) {
      getVenuesApi(sitecoreContext).then(response => {
        if (get(response, 'data.user.venues')) {
          const venues = get(response, 'data.user.venues', []);
          const ids = venues.map(v => v.venueId.split('-').join(''));
          localStorage.setItem('shortlistVenues', JSON.stringify(ids));
          document.body.dispatchEvent(new Event('shortlistVenues'));
        }
      });
    }
  }, []);
  useEffect(() => {
    if (appLocationPath !== '' && appLocation.pathname !== appLocationPath) {
      setOpenBar(false);
    }
    if (appLocationPath === '') {
      setAppLocationPath(appLocation.pathname);
    }
  }, [appLocation]);
  useEffect(() => {
    let timeout;
    const shortlistedVenues = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
    if (!!loadNo) {
      if (shortlistedVenues.length) {
        setOpenBar(true);
      }
      if (!cards.length) {
        timeout = setTimeout(() => {
          setOpenBar(false);
        }, 2000);
      }
    } else {
      timeout = setTimeout(() => {
        setOpenBar(false);
      }, 2000);
    }
    return () => clearTimeout(timeout);
  }, [cards]);
  const triggerInteraction = () => {
    if (isInteractionAvaialble) {
      setIsInteractionAvaialble(false);
      tealiumClickFunc(interactionWithVenueRPFormAnalytics);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: `venue-shortlist__container ${isOpen ? 'venue-shortlist__container-open' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__title"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Back",
    className: "btn--reset venue-shortlist__back",
    tabIndex: isOpen ? 0 : -1,
    onKeyPress: e => {
      if (e.which === 13) {
        e.preventDefault();
        setIsInteractionAvaialble(!isOpen);
        setOpen(!isOpen);
      }
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007CBA",
    fillRule: "nonzero",
    d: "M7.712 4a2.14 2.14 0 0 1-.284 2.927L4.996 9.045H19v1.913H4.996l2.432 2.116c.857.745.981 2.03.284 2.926L1 10l6.712-6z"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__title-text"
  }, getDictionaryItem(dictionaryValues, 'your shortlist') || 'Title', ' ', cards.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, "(", cards.length, ")") : null), /*#__PURE__*/React.createElement("button", {
    className: "btn--reset venue-shortlist__close",
    tabIndex: isOpen ? 0 : -1,
    onKeyPress: e => {
      if (e.which === 13) {
        e.preventDefault();
        setIsInteractionAvaialble(!isOpen);
        setOpen(!isOpen);
      }
    },
    title: closeVenuesLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, closeVenuesLabel), /*#__PURE__*/React.createElement("svg", {
    className: "",
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.974",
    height: "12.974",
    viewBox: "0 0 12.974 12.974"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.72,3.22l1.06,1.06L10.06,9l4.72,4.72-1.06,1.06L9,10.06,4.28,14.78,3.22,13.72,7.94,9,3.22,4.28,4.28,3.22,9,7.94l4.72-4.72Z",
    transform: "translate(-2.513 -2.513)",
    fill: "#007cba",
    stroke: "#007cba",
    "stroke-width": "1"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__body",
    ref: contentBody
  }, !!cards.length ? /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__desc"
  }, getDictionaryItem(dictionaryValues, 'how shortlist works') || '%how shortlist works%') : null, !cards.length ? /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__desc"
  }, getDictionaryItem(dictionaryValues, 'your shortlist is empty') || '%your shortlist is empty%') : null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__cards"
  }, cards.map(card => /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__card",
    key: card.objectID
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__card-category"
  }, card.category), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__card-title"
  }, card.title), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__card-stars"
  }, [/*#__PURE__*/React.createElement("img", {
    src: IconStar,
    alt: "Star1"
  }), /*#__PURE__*/React.createElement("img", {
    src: IconStar,
    alt: "Star2"
  }), /*#__PURE__*/React.createElement("img", {
    src: IconStar,
    alt: "Star3"
  }), /*#__PURE__*/React.createElement("img", {
    src: IconStar,
    alt: "Star4"
  }), /*#__PURE__*/React.createElement("img", {
    src: IconStar,
    alt: "Star5"
  })].slice(0, parseInt(card.hotelStarRating))), /*#__PURE__*/React.createElement(ShortlistBtn, {
    checked: true,
    id: card.objectID,
    sitecoreContext: sitecoreContext,
    title: card.title,
    analytics: {
      remove: removeVenueFromShortlistAnalytics
    }
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__line"
  }), formShareSent ? /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share"
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-title"
  }, getDictionaryItem(venuesDictionaryValues, 'shareYourShortlist') || '%shareYourShortlist%'), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-desc-link-title"
  }, getDictionaryItem(venuesDictionaryValues, 'shareThankYouMessage') || '%shareThankYouMessage%'), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-desc-link",
    onClick: () => setFormShareSent(false)
  }, getDictionaryItem(venuesDictionaryValues, 'shareAgain') || '%shareAgain%', " ", /*#__PURE__*/React.createElement(IconToggleArrowDown, null)))) : null, !formShareSent ? /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share"
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-title"
  }, getDictionaryItem(venuesDictionaryValues, 'shareYourShortlist') || '%shareYourShortlist%'), /*#__PURE__*/React.createElement("input", {
    value: formShare,
    onChange: () => {},
    onInput: e => {
      setFormShare(e.target.value);
    },
    autoComplete: "off",
    placeholder: getDictionaryItem(venuesDictionaryValues, 'enterEmailAddress') || '%enterEmailAddress%',
    type: "text",
    className: "venue-shortlist__share-input",
    tabIndex: isOpen ? 0 : -1
  }), formShareError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formShareError) : null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-desc"
  }, /*#__PURE__*/React.createElement("input", {
    type: "submit",
    onClick: shareEmails,
    className: "btn btn-secondary venue-shortlist__share-submit",
    value: getDictionaryItem(venuesDictionaryValues, 'share') || '%share%',
    tabIndex: isOpen ? 0 : -1
  }), /*#__PURE__*/React.createElement("span", null, getDictionaryItem(venuesDictionaryValues, 'emailFieldDescription') || '%emailFieldDescription%')), isOpen && /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaShareEmailError,
    ref: recaptchaShareEmailRef
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__line"
  }), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__req"
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__req-title"
  }, getDictionaryItem(venuesDictionaryValues, 'requestProposal') || '%requestProposal%'), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__req-desc"
  }, getDictionaryItem(venuesDictionaryValues, 'requestProposalDescription') || '%requestProposalDescription%'), /*#__PURE__*/React.createElement("label", {
    className: `venue-shortlist__req-label ${formFullNameError ? 'venue-shortlist__req-label_error' : ''}`,
    htmlFor: `venue-shortlist__req-full-name-${formIdModifier}`
  }, getDictionaryItem(venuesDictionaryValues, 'fullName') || '%fullName%', " ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement("input", {
    value: formFullName,
    onChange: e => {
      triggerInteraction();
      setFormFullName(e.target.value);
      setFormFullNameError('');
    },
    type: "text",
    id: `venue-shortlist__req-full-name-${formIdModifier}`,
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), formFullNameError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formFullNameError) : null, /*#__PURE__*/React.createElement("label", {
    className: `venue-shortlist__req-label ${formEmailError ? 'venue-shortlist__req-label_error' : ''}`,
    htmlFor: `venue-shortlist__req-email-${formIdModifier}`
  }, getDictionaryItem(venuesDictionaryValues, 'email') || '%email%', " ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement("input", {
    value: formEmail,
    onChange: e => {
      triggerInteraction();
      setFormEmail(e.target.value);
      setFormEmailError('');
    },
    type: "email",
    autoComplete: "off",
    id: `venue-shortlist__req-email-${formIdModifier}`,
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), formEmailError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formEmailError) : null, /*#__PURE__*/React.createElement("label", {
    className: `venue-shortlist__req-label ${formPhoneError ? 'venue-shortlist__req-label_error' : ''}`,
    htmlFor: `venue-shortlist__req-phone-${formIdModifier}`
  }, getDictionaryItem(venuesDictionaryValues, 'phone') || '%phone%'), /*#__PURE__*/React.createElement("input", {
    value: formPhone,
    onChange: e => {
      triggerInteraction();
      setFormPhone(e.target.value);
      setFormPhoneError('');
    },
    type: "text",
    id: `venue-shortlist__req-phone-${formIdModifier}`,
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), formPhoneError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formPhoneError) : null, /*#__PURE__*/React.createElement("div", {
    className: `venue-shortlist__date ${formStartDateError ? 'venue-shortlist__date_error' : ''} ${isOpen ? '' : 'd-none'}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "venue-shortlist__req-label"
  }, getDictionaryItem(venuesDictionaryValues, 'evenDates') || '%evenDates%', " ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement(DateRange, {
    clearAlllFilters: true,
    fields: {
      name: 'Date Range',
      title: {
        jss: {
          value: getDictionaryItem(venuesDictionaryValues, 'selectDate') || '%selectDate%'
        }
      },
      fieldNameItem: {
        item: {
          filedName: {
            value: 'datesRange'
          }
        }
      },
      fieldTypeItem: {
        item: {
          fieldType: {
            value: 'Date Range'
          }
        }
      }
    },
    ignoreQueryString: true,
    clearAllCallback: () => {
      setFormStartDate('');
      setFormEndDate('');
    },
    buttonBlue: true,
    pickDate: getDictionaryItem(venuesDictionaryValues, 'pickDate') || '%pickDate%',
    showLabel: getDictionaryItem(venuesDictionaryValues, 'show') || '%show%',
    resultsLabel: getDictionaryItem(venuesDictionaryValues, 'result') || '%result%',
    facetsName: ['datesRange'],
    clearAllLabel: getDictionaryItem(venuesDictionaryValues, 'clearAll') || '%clearAll%',
    setFilter: (date, _, dateInit) => {
      const [startDate, endDate] = dateInit;
      setFormStartDateError('');
      var tzoffset = new Date().getTimezoneOffset() * 60000;
      if (startDate) {
        const startDateISO = new Date(startDate.getTime() - tzoffset).toISOString().split('T')[0];
        setFormStartDate(startDateISO);
      } else {
        setFormStartDate('');
      }
      if (endDate) {
        const endDateISO = new Date(endDate.getTime() - tzoffset).toISOString().split('T')[0];
        setFormEndDate(endDateISO);
      } else {
        setFormEndDate('');
      }
    },
    wrapperToggle: () => {},
    setSubpanelLabel: () => {},
    lang: currentLang,
    analytics: {
      filterAnalytics: interactionWithVenueRPFormAnalytics,
      filterShowResultsAnalytics: interactionWithVenueRPFormAnalytics,
      filterSelectDateAnalytics: interactionWithVenueRPFormAnalytics,
      filterClearAllDateAnalytics: interactionWithVenueRPFormAnalytics,
      params: {}
    },
    fullWidth: true
  })), /*#__PURE__*/React.createElement("div", null), formStartDateError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formStartDateError) : null, /*#__PURE__*/React.createElement("label", {
    className: `venue-shortlist__req-label ${formNumberOfDelegatesError ? 'venue-shortlist__req-label_error' : ''}`,
    htmlFor: `venue-shortlist__req-no-of-del-${formIdModifier}`
  }, getDictionaryItem(venuesDictionaryValues, 'numberDelegates') || '%numberDelegates%', " ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement("input", {
    value: formNumberOfDelegates,
    onChange: e => {
      triggerInteraction();
      setFormNumberOfDelegates(e.target.value ? parseInt(e.target.value) || 1 : undefined);
      setFormNumberOfDelegatesError('');
    },
    type: "text",
    id: `venue-shortlist__req-no-of-del-${formIdModifier}`,
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), formNumberOfDelegatesError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formNumberOfDelegatesError) : null, /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label",
    htmlFor: `venue-shortlist__req-ev-name-${formIdModifier}`
  }, getDictionaryItem(venuesDictionaryValues, 'eventName') || '%eventName%'), /*#__PURE__*/React.createElement("input", {
    value: formEventName,
    onChange: e => {
      triggerInteraction();
      setFormEventName(e.target.value);
    },
    type: "text",
    id: `venue-shortlist__req-ev-name-${formIdModifier}`,
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label",
    htmlFor: `venue-shortlist__req-com-name-${formIdModifier}`
  }, getDictionaryItem(venuesDictionaryValues, 'companyName') || '%companyName%'), /*#__PURE__*/React.createElement("input", {
    value: formCompanyName,
    onChange: e => {
      triggerInteraction();
      setFormCompanyName(e.target.value);
    },
    type: "text",
    id: `venue-shortlist__req-com-name-${formIdModifier}`,
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label",
    htmlFor: `venue-shortlist__req-comments-${formIdModifier}`
  }, getDictionaryItem(venuesDictionaryValues, 'comments') || '%comments%'), /*#__PURE__*/React.createElement("textarea", {
    value: formComments,
    onChange: e => {
      triggerInteraction();
      setFormComments(e.target.value);
    },
    rows: 7,
    id: `venue-shortlist__req-comments-${formIdModifier}`,
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  })), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__line venue-shortlist__line-mr"
  }), /*#__PURE__*/React.createElement("div", {
    className: `${isOpen ? '' : 'd-none'} venue-shortlist__docs`
  }, /*#__PURE__*/React.createElement(FileUpload, {
    title: getDictionaryItem(venuesDictionaryValues, 'uploadEventProposal'),
    changeHandler: handleFormFiles,
    onChangeError: error => setFormFilesError(error),
    placeholderText: 'test',
    name: 'test',
    openParent: isOpen,
    submitted: submitted,
    validate: true,
    onChangeEvent: () => {},
    itemId: `test-${formIdModifier}`,
    fieldKey: 'test',
    defaultEvent: () => {},
    errors: [],
    singleFile: true,
    fullWidth: true,
    btnPrimaryClassName: 'btn-secondary',
    required: true,
    cssClass: 'test',
    labelCssClass: 'test',
    fileSizeUnit: 1000,
    formDictionaries: {},
    dictionary: fields.dictionary.dictionaryVenues
  }), formFilesError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formFilesError) : null), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__line venue-shortlist__line-footer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__footer"
  }, isOpen && /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary venue-shortlist__req-submit",
    onClick: onSubmit,
    tabIndex: isOpen ? 0 : -1
  }, getDictionaryItem(venuesDictionaryValues, 'submit') || '%submit%')))), loading && /*#__PURE__*/React.createElement("div", {
    className: "Listing Listing--loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null)))))), venueThankYouPage !== '/' ? /*#__PURE__*/React.createElement("div", {
    className: `venue-header__bar ${openBar ? 'venue-header__bar_animated' : ''} ${removedVenue && cards.length === 0 ? 'venue-header__bar_removed' : ''}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "venue-header__bar-title"
  }, removedVenue ? cards.length > 0 ? getDictionaryItem(dictionaryValues, 'venueUnshortlisted') || '%venueUnshortlisted%' : getDictionaryItem(venuesDictionaryValues, 'noVenuesInShortlist') || '%noVenuesInShortlist%' : getDictionaryItem(dictionaryValues, 'venue shortlisted') || '%venue shortlisted%'), cards.length > 0 ? /*#__PURE__*/React.createElement("button", {
    className: "btn venue-header__bar-btn",
    tabIndex: isOpen ? 0 : -1
  }, getDictionaryItem(dictionaryValues, 'your shortlist'), " (", cards.length, ")") : null) : null);
};
const commonStyles = "c15y9uzi";
const ltrStyles = "l1gtps9e";
const rtlStyles = "rel0g51";
const dateStylesLtr = "d60mhcn";
const dateStylesRtl = "d1lg0z12";
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${rtl ? dateStylesRtl : dateStylesLtr}`,
    componentTabIndex: "disabled"
  }, children);
};
export default VenueShortlist;